import { ReactNode } from 'react'

import { BackedByChartItem } from '../types'
import { mapCategoryToLabel } from '../utils'
import { Info } from '@/ui/molecules/info/Info'

export function CategoryTitle({ category }: { category: BackedByChartItem['category'] }): ReactNode {
  const label = mapCategoryToLabel(category)
  if (category === 'onchain_crypto_lending') {
    return (
      <div className="flex flex-row items-center gap-0.5">
        <div>{label}</div>
        <Info>
          Onchain Crypto Lending refers to over-collateralized lending against blue-chip crypto-native assets such as
          BTC, ETH and LSTs/LRTs.
        </Info>
      </div>
    )
  }

  return label
}
